var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyCouponActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#FEE5F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14C13.9696 14 13.4609 14.2107 13.0858 14.5858C12.7107 14.9609 12.5 15.4696 12.5 16V20C13.0304 20 13.5391 20.2107 13.9142 20.5858C14.2893 20.9609 14.5 21.4696 14.5 22C14.5 22.5304 14.2893 23.0391 13.9142 23.4142C13.5391 23.7893 13.0304 24 12.5 24V28C12.5 28.5304 12.7107 29.0391 13.0858 29.4142C13.4609 29.7893 13.9696 30 14.5 30H30.5C31.0304 30 31.5391 29.7893 31.9142 29.4142C32.2893 29.0391 32.5 28.5304 32.5 28V24C31.9696 24 31.4609 23.7893 31.0858 23.4142C30.7107 23.0391 30.5 22.5304 30.5 22C30.5 21.4696 30.7107 20.9609 31.0858 20.5858C31.4609 20.2107 31.9696 20 32.5 20V16C32.5 15.4696 32.2893 14.9609 31.9142 14.5858C31.5391 14.2107 31.0304 14 30.5 14H14.5ZM26 17L27.5 18.5L19 27L17.5 25.5L26 17ZM19.31 17.04C20.29 17.04 21.08 17.83 21.08 18.81C21.08 19.2794 20.8935 19.7296 20.5616 20.0616C20.2296 20.3935 19.7794 20.58 19.31 20.58C18.33 20.58 17.54 19.79 17.54 18.81C17.54 18.3406 17.7265 17.8904 18.0584 17.5584C18.3904 17.2265 18.8406 17.04 19.31 17.04ZM25.69 23.42C26.67 23.42 27.46 24.21 27.46 25.19C27.46 25.6594 27.2735 26.1096 26.9416 26.4416C26.6096 26.7735 26.1594 26.96 25.69 26.96C24.71 26.96 23.92 26.17 23.92 25.19C23.92 24.7206 24.1065 24.2704 24.4384 23.9384C24.7704 23.6065 25.2206 23.42 25.69 23.42Z",
    fill: "#F01272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyCouponActive);
export default __webpack_public_path__ + "static/media/myCouponActive.50387c99dcee739e6af5de740c48d952.svg";
export { ForwardRef as ReactComponent };